var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgYoutube = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 1.875C17.25 2.125 17.3021 2.4375 17.3438 2.8125C17.4062 3.1875 17.4479 3.5625 17.4688 3.9375C17.4896 4.29167 17.5 4.625 17.5 4.9375C17.5208 5.25 17.5312 5.51042 17.5312 5.71875V6C17.5312 7.875 17.4167 9.26042 17.1875 10.1562C17.0833 10.5104 16.8958 10.8229 16.625 11.0938C16.3542 11.3646 16.0312 11.5521 15.6562 11.6562C15.2604 11.7604 14.5104 11.8438 13.4062 11.9062C12.3021 11.9479 11.2917 11.9792 10.375 12H9C5.4375 12 3.21875 11.8854 2.34375 11.6562C1.53125 11.4271 1.02083 10.9271 0.8125 10.1562C0.708333 9.76042 0.625 9.21875 0.5625 8.53125C0.520833 7.82292 0.489583 7.22917 0.46875 6.75V6C0.46875 4.14583 0.583333 2.77083 0.8125 1.875C0.916667 1.5 1.10417 1.17708 1.375 0.90625C1.64583 0.635417 1.96875 0.447917 2.34375 0.34375C2.73958 0.239583 3.48958 0.166667 4.59375 0.125C5.69792 0.0625 6.70833 0.0208333 7.625 0H9C12.5625 0 14.7812 0.114583 15.6562 0.34375C16.0312 0.447917 16.3542 0.635417 16.625 0.90625C16.8958 1.17708 17.0833 1.5 17.1875 1.875ZM7.25 8.5625L11.7188 6L7.25 3.46875V8.5625Z",
    fill: "#333333"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgYoutube, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "1642699981952/static/media/youtube.234e8844.svg";
export { ForwardRef as ReactComponent };